import { gql } from "@apollo/client";

const schema = {
  get: {
    name: "unit",
    serviceName: "graphql",
    query: gql`
      query unit($ids: [String], $for_admin: Int) {
        unit(ids: $ids, for_admin: $for_admin) {
          data {
            id
            lat
            lng
            type
            title
            alias
            is_active
            manager {
              id
            }
          }
        }
      }
    `,
  },
  update: {
    name: "updateUnit",
    serviceName: "unitadmin",
    query: gql`
      mutation updateUnit(
        $ids: [String]!
        $type: String
        $title: String
        $alias: String
        $lat: String
        $lng: String
        $city: String
        $state: String
        $is_active: Int
        $manager_id: String
        $default_lab_items: [DefaultLabInput]
      ) {
        updateUnit(
          ids: $ids
          type: $type
          title: $title
          alias: $alias
          lat: $lat
          lng: $lng
          city: $city
          state: $state
          is_active: $is_active
          manager_id: $manager_id
          default_lab_items: $default_lab_items
        ) {
          influenced_count
          messages
        }
      }
    `,
  },
};

export default schema;
